import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useAuthProvider } from '../../providers/Auth';
import { ProfileProvider } from '../../providers/Profile';
import { UserRole } from '../../types';
import Loading from '../Loading';
import { checkPermissions } from '../Permissions';
import { lazyWithRetry } from '../../utils/lazyWithRetry';
import { useConfig } from '../../providers/Config';

const Home = lazyWithRetry(() => import('../../pages/Home'));
const MobileNumber = lazyWithRetry(() => import('../../pages/App/MobileNumber'));
const Tasks = lazyWithRetry(() => import('../../pages/App/Tasks'));
const Account = lazyWithRetry(() => import('../../pages/App/Account'));
const Assets = lazyWithRetry(() => import('../../pages/App/Assets'));
const People = lazyWithRetry(() => import('../../pages/App/People'));
const PerformanceStats = lazyWithRetry(() => import('../../pages/App/PerformanceStats'));

export const PrivateRouter: React.FC = () => {
  const { userProfile } = useAuthProvider();
  const { featureFlags } = useConfig();

  const isServiceUser = userProfile
    ? checkPermissions(userProfile['custom:ap_role'], [UserRole.SVCUSR, UserRole.SVCUSR_SPR])
    : undefined;

  return (
    <React.Fragment>
      {userProfile && typeof isServiceUser !== 'undefined' ? (
        <ProfileProvider>
          <Switch>
            {/* Only service users can see the webchat page */}
            {isServiceUser && <Route path="/app" exact={true} render={() => <Home />} />}
            {/* For any other user we redirect to the task list */}
            {!isServiceUser && <Redirect path="/app" exact={true} to="/app/tasks" />}
            <Route path="/app/verify-number" render={() => <MobileNumber />} />
            <Route path="/app/tasks" render={() => <Tasks />} />
            <Route path="/app/account" render={() => <Account />} />
            <Route path="/app/assets" render={() => <Assets />} />
            <Route path="/app/people" render={() => <People />} />
            {featureFlags.enablePerfStats && (
              <Route path="/app/performance-stats" render={() => <PerformanceStats />} />
            )}
            <Redirect
              from="*"
              to={{
                pathname: '/404',
                state: { homeLink: '/app' },
              }}
            />
          </Switch>
        </ProfileProvider>
      ) : (
        <Loading />
      )}
    </React.Fragment>
  );
};

export default PrivateRouter;
